import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ExistingFileData } from "../../../types";
import * as uploadStyles from "../styles_vanilla.css";

interface ReadOnlyFileCardProps {
  fileData: ExistingFileData;
}

const ReadOnlyFileCard: React.FC<ReadOnlyFileCardProps> = ({ fileData }) => {
  return (
    <Flex className={uploadStyles.fileCardReady} gap={Sizes.MD} alignItems="flex-start">
      <Flex className={uploadStyles.fileIconContainerReady}>
        <Icon type="file-alt" size="x-large" className={uploadStyles.fileIconReady} />
      </Flex>

      <Flex flexDirection="column" gap={Sizes.SM} className={uploadStyles.fileContentSection}>
        <Flex justifyContent="space-between" alignItems="flex-start">
          <Flex flexDirection="column" gap={Sizes.XS}>
            <Text variant="strong-xl" color={Colors.Neutral900}>
              {fileData.fileName}
            </Text>
            <Text variant="regular-md" className={uploadStyles.fileMetadataText}>
              {fileData.fileSize}
            </Text>
          </Flex>
          <Flex alignItems="center" gap={Sizes.XS}>
            <Icon type="lock" size="small" color={Colors.Neutral600} />
            <Text variant="regular-sm" color={Colors.Neutral600}>
              Read Only
            </Text>
          </Flex>
        </Flex>

        <Flex alignItems="center" gap={Sizes.SM}>
          <Text variant="regular-md" color={Colors.Neutral700}>
            Data Type:
          </Text>
          <Flex className={uploadStyles.dataTypeChip} alignItems="center" gap={Sizes.XS}>
            <Text variant="strong-sm" color={Colors.Neutral900}>
              {fileData.entityType}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ReadOnlyFileCard;
